import { useContext } from "react";
import { CommissionReportsDashboardContext } from "./Commission.provider";

export function useCommissionReportsDashboardContext() {
  const context = useContext(CommissionReportsDashboardContext);

  if (!context) {
    throw new Error("useCommissionDashboardContext deve ser utilizado apenas dentro de CommissionProvider")
  }

  return context
}